import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { TEXTURE_SILK } from "@/data/media";

const WORDS = [
  "eleganza",
  "competenza",
  "coraggio",
  "visione",
  "sorellanza",
  "impresa",
];

export const SilkBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.4, 1], [0.55, 0.85, 0.55]);

  return (
    <section
      ref={ref}
      className="relative overflow-hidden py-20 sm:py-24"
      data-testid="silk-band"
      aria-label="Valori di DonnaImpresa"
    >
      <motion.img
        src={TEXTURE_SILK}
        alt=""
        aria-hidden="true"
        style={{ y, opacity }}
        className="absolute inset-0 h-[130%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#FAF9F6]/95 via-[#FAF9F6]/78 to-[#FAF9F6]/95" />

      <div className="relative mx-auto max-w-[1400px] px-5 text-center sm:px-10">
        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#5E2A52]">
          Un itinerario per professioniste
        </p>
        <h2 className="mx-auto mt-6 max-w-3xl font-display text-3xl italic leading-tight tracking-tight text-[#1A1617] sm:text-4xl lg:text-5xl">
          “Non chiediamo il permesso di esserci:
          <span className="di-shine not-italic"> costruiamo il tavolo</span>.”
        </h2>

        <div className="di-marquee-wrap mt-12 overflow-hidden">
          <div className="di-marquee-slow flex w-max items-center gap-8">
            {[...WORDS, ...WORDS].map((w, i) => (
              <span
                key={i}
                className="whitespace-nowrap font-display text-2xl text-[#5E2A52]/70 sm:text-3xl"
              >
                {w}
                <span className="ml-8 text-[#E0708A]/60">✦</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
